// Components/MessagesArea/components/LoginContainer.jsx
import React from 'react';
import { Box } from '@mui/material';
import Loggin from '../../Loggin';

const LoginContainer = ({ isMobile, setUserSystem }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            }}
        >
            <Loggin isMobile={isMobile} setUserSystem={setUserSystem} />
        </Box>
    );
};

export default LoginContainer;